<template>
  <div class="ba-w-100">
    <div class="body-container-graph">
    </div>
  </div>
</template>

<script>

  require('./../../../../static/charts/dist/Chart.bundle.min.js');

  import {
    getDataGraphs
  } from '@/js/services/editor/website';

  export default {
    name: 'Overview',
    components: {},
    data() {
      return {
        website: {}
      };
    },

    methods: {
      buildChart(data, type, title, displayLegend, placeAt) {

        if (typeof placeAt === 'undefined') {
          placeAt = $('.body-container-graph');
        }
        let divContainer = $('<div>').addClass('container-graph ' + type).appendTo(placeAt);
        let canvasContainer = $('<canvas>').appendTo(divContainer);

        if(Object.keys(data).length > 8 && type === 'doughnut'){
          while (Object.keys(data).length > 8){
            for (var i in data) {
              let idexToRemove = i;
              for (var j in data) {
                if(data[j] < data[i]){
                  idexToRemove = j;
                }
              }
              delete data[idexToRemove];
              if(Object.keys(data).length <= 8)
                break;
            }
          }
        }

        var labels = [];
        var dataSet = [];
        var count = 0;
        for (var i in data) {
          if (i !== 'Unknown') {
            count++;
            labels.push(i !== '' ? i : 'home');
            dataSet.push(data[i]);
          }
        }

        var ctx = canvasContainer.get(0).getContext('2d');
        new Chart(ctx, {
          type: type,
          data: {
            labels: labels,
            datasets: [{
              data: dataSet,
              borderColor: type === 'line' ? '#109CF1' : 'white',
              borderWidth: type === 'line' ? 3 : 1,
              backgroundColor: (context) => {
                if(type == 'line') {
                  const ctx = context.chart.ctx;
                  const gradient = ctx.createLinearGradient(0, 0, 0, 700);
                  gradient.addColorStop(0, "rgba(16, 156, 241, 0.6)");
                  gradient.addColorStop(1, "rgba(255, 255, 255, 0.6)");
                  return gradient;
                } else {
                  return [
                    '#0072E1',
                    '#176BA0',
                    '#19AADE',
                    '#1DE4BD',
                    '#7D3AC1',
                    '#AF4BCE',
                    '#DB4CB2',
                    '#EA7369',
                    '#820401',
                    '#C02323',
                    '#EF7E32',
                    '#EE9A3A',
                    '#E7E34E'
                  ]
                }
              }
              // backgroundColor: type === 'line' ? '#0072E1' : [
              //   '#0072E1',
              //   '#176BA0',
              //   '#19AADE',
              //   '#1DE4BD',
              //   '#7D3AC1',
              //   '#AF4BCE',
              //   '#DB4CB2',
              //   '#EA7369',
              //   '#820401',
              //   '#C02323',
              //   '#EF7E32',
              //   '#EE9A3A',
              //   '#E7E34E'
              // ]
            }]
          },
          options: {
            bezierCurve: false,
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 80,
            title: {
              display: type === 'line' ? false : true,
              text: this.$t(title),
              fontSize: 16,
              fontFamily: "'Montserrat', 'sans-serif'",
              position: 'top'
            },
            legend: {
              display: displayLegend,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                boxWidth: 30,
                fontSize: 12,
                fontColor: '#0072E1'
              }
            },
            elements: {
              line: {
                fill: true
              }
            }, 
            scales: type == 'line' ? {
                xAxes: [{
                    gridLines: {
                        color: "#D3D8DD"
                    }
                }],
                yAxes: [{
                    gridLines: {
                        borderDash: [8, 4],
                        color: "#D3D8DD"
                    }
                }]
            } : {}
          }
        });

        return divContainer;
      }

    },

    async created() {

      let vm = this;

      this.$loading.show();

      await getDataGraphs(this.$route.params.id)
        .then(websiteData => {
            if (websiteData.data.browser.length === 0 && websiteData.data.device.length === 0 && websiteData.data.system.length === 0 && websiteData.data.date.length === 0) {
              $('<div>').addClass('alert-info text-center').text(vm.$t('ct-empty-data')).appendTo($('.body-container-graph'));
            } else {
              if (websiteData.data.browser.length !== 0) {
                vm.buildChart(websiteData.data.browser, 'doughnut', 'ct-browser-graph', true)
              }
              if (websiteData.data.device.length !== 0) {
                vm.buildChart(websiteData.data.device, 'doughnut', 'ct-device-graph', true)
              }
              if (websiteData.data.system.length !== 0) {
                vm.buildChart(websiteData.data.system, 'doughnut', 'ct-system-graph', true)
              }
              if (websiteData.data.date.length !== 0) {
                try {
                  let dateObj = {};
                  let lang = window.getCookie('languageEditorUser').replace('_', '-');
                  Object.keys(websiteData.data.date).forEach(function (item) {
                    dateObj[new Date(item).toLocaleDateString(lang)] = websiteData.data.date[item];
                  });
                  vm.buildChart(dateObj, 'line', 'ct-date-graph', false)
                } catch (e) {
                  vm.buildChart(websiteData.data.date, 'line', 'ct-date-graph', false)
                }
              }
            }
          }
        )
        .catch(error => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());

      window.vm.$Progress.finish();
      // getDataAccess(this.$route.params.id)
      //   .then(website => {
      //     console.log('getDataAccess', website);
      //   })
      //   .catch(error => {
      //     console.warn(error);
      //     if (error.response.data.errors) {
      //       this.errors.record({website: error.response.data.errors})
      //     }
      //   });
    }
  };
</script>

<style>
  .container-graph {
    width: 33%;
    min-height: 200px;
    max-height: 400px;
    display: inline-block;
  }

  .container-graph.line {
    margin-top: 40px;
    width: 100%;
    height: 400px;
  }
</style>
<style scoped>

  .header-titles {
    padding: 0;
  }

  .body-container-graph {
    padding: 50px;
    margin-top: 5px;
    background: white;
  }


</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Overview.vue